import api from "api/axios";
import { cvApiBase } from "./CvProcessorApi";

export interface CvCategory {
  id: number;
  name: string;
  skills_pool: string[];
  is_active: boolean;
  is_system: boolean;
  is_skill_family: boolean;
  created_at: string | null;
  updated_at: string | null;
}

export interface CvCategoryCreate {
  name: string;
  skills_pool?: string[];
  is_active?: boolean;
  is_system?: boolean;
  is_skill_family?: boolean;
}

export interface CvCategoryUpdate {
  name?: string;
  skills_pool?: string[];
  is_active?: boolean;
  is_system?: boolean;
  is_skill_family?: boolean;
}

export async function listCategories(): Promise<CvCategory[]> {
  const res = await api.get(`${cvApiBase()}/categories`);
  return res.data;
}

export async function createCategory(payload: CvCategoryCreate): Promise<CvCategory> {
  const res = await api.post("/admin/cv-processor/categories", payload);
  return res.data;
}

export async function updateCategory(id: number, payload: CvCategoryUpdate): Promise<CvCategory> {
  const res = await api.patch(`/admin/cv-processor/categories/${id}`, payload);
  return res.data;
}

export async function deleteCategory(id: number): Promise<void> {
  await api.delete(`/admin/cv-processor/categories/${id}`);
}
